
// import axios from "axios";
// import { api } from "../config";
// import { fetchAuthSession } from "aws-amplify/auth";

// const token = localStorage.getItem("token");

// // default
// axios.defaults.baseURL = api.API_URL;
// // content type
// axios.defaults.headers.post["Content-Type"] = "application/json";

// // content type

// if (token) {
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// }

// // intercepting to capture errors
// // axios.interceptors.response.use(
// //   function (response) {
// //     return response.data ? response.data : response;
// //   },
// //   function (error) {
// //     let message;
// //     const errorData = error.response?.data;
// //     switch (error.response?.data) {

// //       case 500:
// //         message =  "Internal Server Error";
// //         break;
// //       case 401:
// //         message ="Invalid credentials";
// //         break;
// //       case 404:
// //         message = errorData?.message || "Sorry! the data you are looking for could not be found";
// //         break;
// //       case 400:
// //         message = errorData?.message || "Bad Request";
// //       default:
// //         message = error.message || error;
// //     }
// //     return Promise.reject({ message,errorData });
// //   }
// // );

// // const initializeAuthorization = async () => {
// //   try {
// //     const session = await fetchAuthSession()
// //     const token = session.tokens.idToken ? session.tokens.idToken : ""
// //     localStorage.setItem("token", token);
// //     setAuthorization(token);
// //   } catch (error) {
// //     console.error("Error getting initial token:", error);
// //   }
// // };

// // // Call to set the initial token on app load
// // initializeAuthorization();

// // Refresh token function for manual handling
// const refreshToken = async () => {
//   try {
//     const session = await fetchAuthSession();
//     const newToken = session.tokens.idToken ? session.tokens.idToken : ""
//     localStorage.setItem("token", newToken);
//     setAuthorization(newToken);
//     return newToken;
//   } catch (error) {
//     console.error("Error refreshing token:", error);
//     await Auth.signOut();
//     window.location.reload();
//     throw error;
//   }
// };

// // Axios response interceptor for handling token expiration
// axios.interceptors.response.use(
//   function (response) {
//     return response.data ? response.data : response;
//   },
//   async function (error) {
//     const errorData = error.response?.data;
//     let message;
//     if (error.response?.status === 401 && errorData?.message === "The incoming token has expired") {
//       try {
//         const newToken = await refreshToken();
//         error.config.headers["Authorization"] = "Bearer " + newToken;
//         return axios.request(error.config); // Retry the original request with new token
//       } catch (refreshError) {
//         return Promise.reject(refreshError);
//       }
//     }

//     switch (error.response?.status) {
//       case 500:
//         message = "Internal Server Error";
//         break;
//       case 401:
//         message = "Invalid credentials";
//         break;
//       case 404:
//         message = errorData?.message || "Sorry! the data you are looking for could not be found";
//         break;
//       case 400:
//         message = errorData?.message || "Bad Request";
//         break;
//       default:
//         message = error.message || error;
//     }
//     return Promise.reject({ message, errorData });
//   }
// );

// /**
//  * Sets the default authorization
//  * @param {*} token
//  */
// const setAuthorization = (token) => {
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// };

// const S3Client = axios.create({
//   // Completely clean axios instance for S3 uploads
// });
// const useAPIClient = () => {
//   const get = (url, params) => {
//     let response;

//     let paramKeys = [];

//     if (params) {
//       Object.keys(params).forEach(key => {
//         paramKeys.push(key + '=' + params[key]);
//       });

//       const queryString = paramKeys.length ? paramKeys.join('&') : "";
//       response = axios.get(`${url}?${queryString}`, { params });
//     } else {
//       response = axios.get(url);
//     }
//     return response;
//   };

//   const create = (url, data) => {
//     return axios.post(url, data);
//   };

//   const update = (url, data) => {
//     return axios.patch(url, data);
//   };

//   const patch = (url, data) => {
//     return axios.patch(url, data);
//   };

//   const put = (url, data) => {
//     return axios.put(url, data);
//   };

//   const deleteRequest = (url, data) => {
//     return axios.delete(url, { data });
//   };



//   return { get, create, update, put, delete: deleteRequest, patch };
// };

// const getLoggedinUser = (() => {
//   const user = localStorage.getItem("authUser");
//   // console.log(user);
//   return user ? JSON.parse(user) : null;
// });

// export { useAPIClient, setAuthorization, getLoggedinUser, S3Client };


import axios from "axios";
import { api } from "../config";
import { fetchAuthSession } from "aws-amplify/auth";

const token = localStorage.getItem("token");

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// Refresh token function for manual handling
const refreshToken = async () => {
  try {
    const session = await fetchAuthSession();
    const newToken = session?.tokens?.idToken ? session?.tokens?.idToken : ""
    localStorage.setItem("token", newToken);
    setAuthorization(newToken);
    return newToken;
  } catch (error) {
    window.location.href = "/logout";
    await Auth.signOut();
    window.location.reload();
    throw error;
  }
};

// Axios response interceptor for handling token expiration
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  async function (error) {
    const errorData = error.response?.data;
    let message;
    // if(error?.response?.data?.message === "Unauthorized") {
    //   window.location.href = "/logout";
    // }
    if (error.response?.status === 401 && errorData?.message === "The incoming token has expired" || error.response?.status === 401 && error?.response?.data?.message === "Unauthorized") {
      try {
        const newToken = await refreshToken();
        if (!newToken) {
          window.location.href = "/logout";
          return Promise.reject(error);
        }
        error.config.headers["Authorization"] = "Bearer " + newToken;
        return axios.request(error.config);
      } catch (refreshError) {
        window.location.href = "/logout";
        return Promise.reject(refreshError);
      }
    }

    switch (error.response?.status) {
      case 500:
        message = errorData?.message || "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = errorData?.message || "Sorry! the data you are looking for could not be found";
        break;
      case 400:
        message = errorData?.message || "Bad Request";
        break;
      default:
        message = error.message || errorData.message;
    }
    return Promise.reject({ message, errorData });
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const S3Client = axios.create({
  // Completely clean axios instance for S3 uploads
});
const useAPIClient = () => {
  const get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).forEach(key => {
        paramKeys.push(key + '=' + params[key]);
      });

      const queryString = paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, { params });
    } else {
      response = axios.get(url);
    }
    return response;
  };

  const create = (url, data) => {
    return axios.post(url, data);
  };

  const update = (url, data) => {
    return axios.patch(url, data);
  };

  const patch = (url, data) => {
    return axios.patch(url, data);
  };

  const put = (url, data) => {
    return axios.put(url, data);
  };

  const deleteRequest = (url, data) => {
    return axios.delete(url, { data });
  };



  return { get, create, update, put, delete: deleteRequest, patch };
};

const getLoggedinUser = (() => {

  const user = localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
});

export { useAPIClient, setAuthorization, getLoggedinUser, S3Client };
